import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import { BsToastService } from '../../../Services/bs-toast-service';
import { ConfirmDialogService } from '../../../Services/confirm-dialog.service';
import { CustomArrayFilterPipe } from '../custom-array-filter.pipe';
import { AppConfigService } from '../../../Services/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from '../../../Services/storage.service';
import { PermissionsService } from '../../../Services/permissions.service';
import {EmailModel} from '../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../send-email-modal/send-email-modal.component';

@Component({
  selector: 'app-batch-new-and-post-modal',
  templateUrl: './batch-new-and-post-modal.component.html',
  styleUrls: ['./batch-new-and-post-modal.component.scss'],
  standalone: false
})
export class BatchNewAndPostModalComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @ViewChild('closeButton') closeButton: ElementRef;
  @ViewChild('EmailContent', {static: false}) EmailContent!: ElementRef<HTMLElement>;
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private emailModalHost: ElementRef;
  searchText: string;
  @Input() subLedger: any;
  @Input() batchType: any;
  @Output() updateItemsDisplayedByBatch = new EventEmitter<any>();

  batchList: any;
  batchCount = 0;
  batchTypeLabel = '';
  vm = {
    batches: [],
    tempBatchLocked: false,
    tempDescription: '',
    tempMyBatch: false,
    lockedBatches: false,
    tempLength: 0,
    batchId: '',
    list: [],
    subLedger: '',
  };
  batchesHidden = true;
  pageSize = this.appConfig.ListPageSize;
  batch: {
    header_count: 0;
    my_batch: boolean;
  };
  isAdmin = false;
  reportBatchId = '';
  batchBeingDisplayed = false;
  permissions: any;
  emailObject: EmailModel = new EmailModel();

  constructor(
    private tableDataService: DataService,
    private notification: BsToastService,
    private confirmDialog: ConfirmDialogService,
    private appConfig: AppConfigService,
    private router: Router,
    private localStorage: StorageService,
    protected perms: PermissionsService,
    private cdr: ChangeDetectorRef
  ) {
    this.permissions = {};
  }

  ngOnInit() {
    // TODO - add more permissions etc. as overall permissions vision becomes more clear
    this.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
    if (this.permissions) {
      this.isAdmin = this.permissions.Admin;
    }
  }

  ngOnChanges() {
    this.getBatches();
  }

  ngAfterViewInit() {}

  getBatches() {
    if (this.batchType) {
      // let tempBatchType: any;
      const tempBatchType = this.batchType;

      let paramString = '';
      paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
      // paramString += '&search=' + ((this.vm.paymentSearch) ? this.vm.paymentSearch : '');
      // paramString += '&fromDate=' + ((this.vm.paymentFromDate) ? this.dateFilter.GetDateFormat(this.vm.paymentFromDate) : '');
      // paramString += '&toDate=' + ((this.vm.paymentToDate) ? this.dateFilter.GetDateFormat(this.vm.paymentToDate) : '');
      paramString += '&lockedBatches=' + this.vm.lockedBatches;
      // paramString += '&includePosted=' + ((this.vm.includePosted) ? this.vm.includePosted : '');
      // console.log(paramString);
      this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
        this.vm.batches = result;
        this.batchList = result;
        this.batchCount = this.batchList.length;
        this.batchTypeLabel = this.resolveBatchTypeLabel();
        // console.log(this.batchList);
        this.setDisplayValues('');
      });
    }
  }

  private resolveBatchTypeLabel(): string {
    // Prefer deriving from the first batch row if available
    const first = Array.isArray(this.batchList) && this.batchList.length ? this.batchList[0] : null;
    const typeId = Number(first?.type_id ?? this.batchType ?? NaN);
    // Common mappings (adjust as needed)
    switch (typeId) {
      case 2:
        return 'AP Invoices';
      case 3:
        return 'AP Payments';
      case 4:
        return 'AR Invoices';
      case 5:
        return 'AR Payments';
      case 9:
        return 'Sales Orders';
      case 10:
        return 'Purchase Orders';
      default: {
        // try string inputs
        if (typeof this.batchType === 'string') {
          return String(this.batchType);
        }
        return 'Batch';
      }
    }
  }

  // --- Print/Email helpers (modeled after activity-feed-modal) ---
  onPrint(): void {
    const html = this.buildPrintHtml();
    this.printHtmlInIframe(html);
  }

  onEmail(): void {
    const html = this.buildPrintHtml();
    const reportName = 'Batch Summary';
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');

    const emailDocObj = {} as EmailModel;
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.toEmail = '';
    emailDocObj.Subject = `AcctXErp ${reportName} (${yyyy}-${mm}-${dd})`;
    emailDocObj.body = `Please see the attached ${reportName}.<br><br>Best regards,<br>AcctXErp`;
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.pdfHtml = html;
    emailDocObj.FileName = `Batch_Summary_${yyyy}${mm}${dd}.pdf`;
    emailDocObj.activity_message = reportName;

    // Bind and flush to render the Send Email modal with new inputs
    this.emailObject = emailDocObj;
    this.cdr.detectChanges();

    // Locate the Send Email modal element similar to Activity Feed
    let emailEl: HTMLElement | null = null;
    try {
      emailEl = (this.emailModalHost?.nativeElement as HTMLElement)?.querySelector?.('#sendEmailModal') || null;
    } catch {
      emailEl = null;
    }
    if (!emailEl) {
      emailEl = document.getElementById('sendEmailModal');
    }
    // Ensure it overlays correctly if nested under this modal
    const container = document.getElementById('batchNewPostModal');
    if (emailEl && container && emailEl.closest('#batchNewPostModal')) {
      document.body.appendChild(emailEl);
    }
    const modal = emailEl ? Modal.getOrCreateInstance(emailEl) : null;
    modal?.show();
  }

  private buildPrintHtml(): string {
    const rawContent = this.EmailContent?.nativeElement?.innerHTML || '';
    // Trim everything before the first table to avoid stray spacer rows between header and table
    const firstTableIdx = rawContent.indexOf('<table');
    const content = firstTableIdx >= 0 ? rawContent.substring(firstTableIdx) : rawContent;
    const styles = `
      <style>
        body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; }
        h2 { margin: 0 0 4px 0; font-size: 18px; }
        .meta { color: #666; margin: 0 0 12px 0; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        thead th { text-align: left; background: #f8f9fa; border-bottom: 1px solid #dee2e6; padding: 6px; }
        tbody td { border-top: 1px solid #eee; padding: 6px; vertical-align: top; }
        /* Hide New (col 1) and Action (col 6) in the report */
        table thead th:nth-child(1),
        table thead th:nth-child(6),
        table tbody td:nth-child(1),
        table tbody td:nth-child(6) { display: none !important; }
        /* Also hide the search inputs (top-left) and the include posted checkbox/label in the report */
        .form-group.row:first-of-type { display: none !important; }
        form.input-group { display: none !important; }
        .text-end { display: none !important; }
        /* Explicitly hide the Search input by placeholder */
        input[placeholder="Search values ..."],
        input[placeholder*="Search"] { display: none !important; }
      </style>
    `;
    const typePart = this.batchTypeLabel ? ` - ${this.batchTypeLabel}` : '';
    const title = `Batch Summary${typePart}`;
    const runAt = this.formatRunDateTime(new Date());
    return `<!doctype html><html><head><meta charset="utf-8"/>${styles}</head><body>
      <h2>${title}</h2>
      <div class="meta">Run: ${runAt} · Total Batches: ${this.batchCount}</div>
      ${content}
    </body></html>`;
  }

  private formatRunDateTime(d: Date): string {
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const HH = String(d.getHours()).padStart(2, '0');
    const MM = String(d.getMinutes()).padStart(2, '0');
    const SS = String(d.getSeconds()).padStart(2, '0');
    return `${mm}/${dd}/${yyyy} ${HH}:${MM}:${SS}`;
  }

  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(html);
      doc.close();
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          document.body.removeChild(iframe);
        }, 100);
      };
    }
  }

  setReportBatchId(batchId) {
    this.reportBatchId = batchId;
  }

  setDisplayValues(batchId) {
    if (!batchId) {
      return;
    }

    // check if users batch and if not notify they can't mod.
    const chkOwner: any = this.batchList.filter((x) => x.id == batchId);

    if (!chkOwner[0].my_batch && !this.perms.Get('Admin')) {
      this.notification.showWarningToast('Not batch owner. Cannot modify');
    }

    // todo do we let them even see whats in batches if NOT admin?
    this.vm.tempDescription = '';

    this.vm.batchId = batchId;

    // this.vm.tempDescription = 'Batch';
    const obj: any = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true);
    if (obj.length == 0) {
      obj[0] = { description: '', locked: '', tempMyBatch: false, header_count: 0 };
    }
    this.vm.tempDescription = obj ? obj[0].description : '';
    this.vm.tempBatchLocked = obj ? obj[0].locked : false;
    this.vm.tempMyBatch = obj ? obj[0].my_batch : false;
    this.vm.tempLength = obj ? obj[0].header_count : 0;
  }

  includePosted(event: any) {
    // console.log('checked: ' + event.target.checked);
    // console.log('vm locked: ' + this.vm.lockedBatches);
    this.getBatches();
  }

  emitUpdateToDisplayedRecords(batchId) {
    this.updateItemsDisplayedByBatch.emit(batchId);
  }

  deleteBatch(batchId: string) {
    const messages: string[] = [
      $localize`:Are you sure you want to delete this Batch? @@areyousureyouwanttodeleterthisbatch:Are you sure you want to delete this Batch?`,
      '',
    ];
    this.confirmDialog.confirmThis(
      messages,
      () => {
        this.tableDataService.deleteDataById('t_batch', batchId).subscribe(
          (result) => {
            this.getBatches();
            // retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.showErrorToast($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            // this.onClose();
            // alert('hello');
          }
        );
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  FilterObject(value, filterObj, except = false) {
    return new CustomArrayFilterPipe().transform(value, filterObj);
  }

  postBatchById(batchId: string) {
    const messages: string[] = [
      $localize`:Are you sure you want to Post this Batch? @@areyousureyouwanttopostrthisbatch:Are you sure you want to Post this Batch?`,
      '',
    ];
    this.confirmDialog.confirmThis(
      messages,
      () => {
        const changes = { locked: 'true' };
        this.tableDataService
          .patch('t_batch', batchId, changes)
          .then((item: any) => {
            if (item) {
              // this.notification.success(item.description);
            }
            this.getBatches();
          })
          .catch((msg: string) => {
            console.log(msg);
          });
      },
      () => {
        this.notification.showSuccessToast($localize`:Post Canceled @@postCanceled:Post Canceled`);
      }
    );
  }

  postBatch(batchId) {
    const changes = { locked: 'true' };
    this.tableDataService
      .patch('t_batch', batchId, changes)
      .then((item: any) => {
        if (item) {
          // this.notification.success(item.description);
        }
        this.getBatches();
      })
      .catch((msg: string) => {
        console.log(msg);
      });
  }

  updateBatch() {
    const changes = { description: this.vm.tempDescription };

    this.tableDataService
      .patch('t_batch', this.vm.batchId, changes)
      .then((item: any) => {
        // this.notification.success(this.vm.tempDescription);
        this.getBatches();
      })
      .catch((msg: string) => {
        console.log(msg);
      });
  }

  newBatch() {
    // let newBatch;
    // if (this.batchType === 3) {
    //   newBatch = { type_id: 3 };
    // } else {
    //   newBatch = { type_id: 5 };
    // }
    const newBatch = {type_id: this.batchType};

    this.tableDataService.post('t_batch', newBatch).subscribe(
      (item: any) => {
        this.getBatches();
        this.vm.batchId = item.id;
      },
      (error: { error: { Message: string }; statusText: string }) => {
        let ErrorMsg: string;
        if (typeof error.error.Message != 'undefined') {
          ErrorMsg = error.error.Message;
        } else {
          ErrorMsg = error.statusText;
        }
        console.log(ErrorMsg);
      }
    );
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }
}
